var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 4.53125H16.5625M1.25 4.53125H3.4375M3.4375 4.53125H16.5625M3.4375 4.53125V16.5625C3.4375 17.1427 3.66797 17.6991 4.0782 18.1093C4.48844 18.5195 5.04484 18.75 5.625 18.75H14.375C14.9552 18.75 15.5116 18.5195 15.9218 18.1093C16.332 17.6991 16.5625 17.1427 16.5625 16.5625V4.53125M6.71875 3.98438C6.71875 3.25917 7.00684 2.56367 7.51963 2.05088C8.03242 1.53809 8.72792 1.25 9.45312 1.25H10.5469C11.2721 1.25 11.9676 1.53809 12.4804 2.05088C12.9932 2.56367 13.2812 3.25917 13.2812 3.98438",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.76f67f4096338b59f9e9ce7e2150f23f.svg";
export { ForwardRef as ReactComponent };